import { Stack, Text } from "@mantine/core"

import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"
import { ProductAttribute } from "@tfg/types/constants/configurations.constants"
import { AGECResponses } from "@tfg/types/endpoints/agec"
import { productAttributesSpacingCSSVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

export type ProductAttributesProps = {
  primaryProductAttributes?: ProductAttribute[]
  secondaryProductAttributes?: ProductAttribute[]
  agecData: AGECResponses.GenericAgecData
}

export const ProductAttributes = ({
  primaryProductAttributes,
  secondaryProductAttributes,
  agecData,
}: ProductAttributesProps) => {
  const primaryInformationText =
    primaryProductAttributes && agecData.productAttributes
      ? primaryProductAttributes
          .map((attribute) => agecData.productAttributes?.[attribute])
          .join(", ")
      : ""
  const secondaryInformationText =
    secondaryProductAttributes && agecData.productAttributes
      ? secondaryProductAttributes
          .map((attribute) => agecData.productAttributes?.[attribute])
          .join(", ")
      : ""
  if (
    primaryInformationText.length == 0 &&
    secondaryInformationText.length == 0
  ) {
    return null
  }
  return (
    <Stack
      gap={DesignStudioParametersToolkit.getCssVariableLiteralName(
        productAttributesSpacingCSSVariable
      )}
    >
      {primaryInformationText.length > 0 && (
        <Text
          className={
            CommunicationStudioClasses.PRODUCT_ATTRIBUTES_PRIMARY_INFORMATION
          }
        >
          {primaryInformationText}
        </Text>
      )}
      {secondaryInformationText.length > 0 && (
        <Text
          className={
            CommunicationStudioClasses.PRODUCT_ATTRIBUTES_SECONDARY_INFORMATION
          }
        >
          {secondaryInformationText}
        </Text>
      )}
    </Stack>
  )
}
